import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBox,
  FaBuilding,
  FaChartLine,
  FaMobileAlt,
  FaChevronLeft,
  FaChevronRight,
  FaSignOutAlt,
  FaBlog,
} from "react-icons/fa";
import '../../styles/Sidebar.css';

const SuperAdminSidebar = ({ user }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = '/';
  };

  return (
    <div className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''}`}>

      {/* Toggle Collapse Button */}
      <button
        className="sidebar-toggle-btn"
        onClick={() => setIsCollapsed(!isCollapsed)}
        title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <NavLink to="/super-admin/dashboard" className="nav-btn" title="Dashboard">
          <FaTachometerAlt className="nav-icon" />
          {!isCollapsed && <span>Dashboard</span>}
        </NavLink>

        <NavLink to="/super-admin/plans" className="nav-btn" title="Plans Management">
          <FaBox className="nav-icon" />
          {!isCollapsed && <span>Plans Management</span>}
        </NavLink>

        <NavLink to="/super-admin/companies" className="nav-btn" title="Companies">
          <FaBuilding className="nav-icon" />
          {!isCollapsed && <span>Companies</span>}
        </NavLink>

        <NavLink to="/super-admin/subscriptions" className="nav-btn" title="Subscriptions">
          <FaChartLine className="nav-icon" />
          {!isCollapsed && <span>Subscriptions</span>}
        </NavLink>

        <NavLink to="/super-admin/trial-users" className="nav-btn" title="Trial Users">
          <FaMobileAlt className="nav-icon" />
          {!isCollapsed && <span>Trial Users</span>}
        </NavLink>

        <NavLink to="/super-admin/blogs" className="nav-btn" title="Create Blog">
          <FaBlog className="nav-icon" />
          {!isCollapsed && <span>Blog Management</span>}
        </NavLink>
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button 
          className="nav-btn" 
          onClick={handleLogout}
          title="Logout"
          style={{ color: '#ef4444' }}
        >
          <FaSignOutAlt className="nav-icon" />
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default SuperAdminSidebar;
